import { render, staticRenderFns } from "./surface_post_being_edited.vue?vue&type=template&id=5f1b3c95&scoped=true&"
import script from "./surface_post_being_edited.vue?vue&type=script&lang=js&"
export * from "./surface_post_being_edited.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_being_edited.vue?vue&type=style&index=0&id=5f1b3c95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b3c95",
  null
  
)

export default component.exports